export default "__VITE_ASSET__CEhtZX3O__"